module.exports = __webpack_public_path__ + "img/service_remittance.165b6056.svg";